import Layout from '@/layout'

const route = {
  path: '/domainnamedetect',
  component: Layout,
  redirect: '/domainnamedetect/index',
  alwaysShow: true, // will always show the root menu
  name: 'domainnamedetect',
  meta: {
    title: '微信域名池',
    icon: 'diy-WzXnYuMyIi',
    roles: [
      'wechatDomain'
    ]
  },
  children: [
    // 域名检查列表
    {
      path: '/domainname/index',
      component: () => import('@/views/domainname/index.vue'),
      name: 'Domainname',
      meta: {
        title: '微信域名池',
        // icon: 'component',
        roles: [
          'domainConfigure.domainConfigureList'
        ]
      }
    }

  ]
}

export default route
